<template>
    <div v-clickaway="closeSlotsTooltip" v-bind="elementProps" @click="toggleSlotsTooltip($event)">
        <span v-if="isToday">
            {{ date.format('D') }}
            <span v-if="!isMobileLarge">{{ $t('pages.referrals.new.microcopy.today') }}</span>
        </span>

        <span v-else>
            {{ date.format('D') }}
        </span>

        <template v-if="hasAvailableSlots">
            <div class="appointment-calendar-day__slots">
                <span v-if="!isMobileLarge">
                    {{ $tc('pages.referrals.new.microcopy.slots', slotsCount) }}
                </span>

                <div ref="tooltip">
                    <schedule-calendar-slots
                        :year="year"
                        :month="month"
                        :day="day"
                        :physician="physician"
                        :practice="practice"
                        :location="location"
                        :isOpen="isSlotsTooltipOpen"
                        @emitEvent="emitEvent($event)"
                    ></schedule-calendar-slots>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import CalendarDayMixin from 'mixins/CalendarDayMixin'
    import ScheduleCalendarSlots from 'components/page-elements/referrals-new-schedule/ScheduleCalendarSlots'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [CalendarDayMixin, ScreenSizeDetectionMixin],

        components: {
            ScheduleCalendarSlots,
        },

        props: {
            location: { type: Object, required: true },
        },

        computed: {
            isToday() {
                return dayjs().isSame(this.date, 'date')
            },

            hasAvailableSlots() {
                return this.slotsCount > 0 && this.date.isSameOrAfter(dayjs(), 'date')
            },
        },
    }
</script>
